import React, {useEffect, useState} from "react";
import { GoogleMap, Marker, DirectionsRenderer, TrafficLayer } from "react-google-maps";
/* global google */

const Map = ({ formattedOrigin, formattedDestination, updateDistanceData }) => {
    const DirectionsService = new google.maps.DirectionsService();
    let [directions, setDirections] = useState("");
    const extractDistance = (result) => {
        const routes = result?.routes[0];
        const leg = routes?.legs[0];
        return {
            distance: leg?.distance?.text,
            time: leg?.duration_in_traffic?.text
        }
    }
    useEffect(() => {
        DirectionsService.route(
            {
                origin: formattedOrigin,
                destination: formattedDestination,
                travelMode: google.maps.TravelMode.DRIVING,
                drivingOptions: {
                    departureTime: new Date(Date.now()), // you can specify the departure time here
                    // trafficModel: trafficModel,
                  },
            },
            (result, status) => {
                if (status === google.maps.DirectionsStatus.OK) {
                    setDirections(result);
                    console.log(result);
                    updateDistanceData(extractDistance(result));
                } else {
                    console.error(`error fetching directions ${result}`);
                }
            }
        );
    }, [formattedOrigin, formattedDestination])
    return (
        <>
        <section className="googleMap">
            <GoogleMap defaultZoom={9} defaultCenter={formattedOrigin}>
                {/* <Marker position={formattedOrigin} />
                <Marker position={formattedDestination} /> */}
                    <TrafficLayer autoUpdate />
                {directions && <DirectionsRenderer directions={directions} />}
            </GoogleMap>
        </section>
        </>
    );
};

export default Map;
